import { ExpandIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

import { RefundChargebackReportSummaryDropdownStyled } from './RefundChargebackReportSummaryDropdown.styled';

type RefundChargebackReportSummaryPeriodProps = {
  toggleIsOpen: () => void;
  isOpen: boolean;
};

export const RefundChargebackReportSummaryDropdown: React.FC<
  RefundChargebackReportSummaryPeriodProps
> = ({ toggleIsOpen, isOpen }) => {
  return (
    <RefundChargebackReportSummaryDropdownStyled isOpen={isOpen}>
      <Typography variant="h6">Итоговая сводка за период</Typography>
      <ExpandIconButton isExpanded={isOpen} onClick={toggleIsOpen} />
    </RefundChargebackReportSummaryDropdownStyled>
  );
};
